
import { EventImageSquare } from "@/components/shared/EventImageSquare";

interface EventImageRoundedProps {
  image?: string | null;
  title: string;
  eventImages?: Array<{
    image_id: string;
    image_url: string;
    is_primary: boolean;
    display_order: number;
  }> | null;
}

export const EventImageRounded = ({ image, title, eventImages }: EventImageRoundedProps) => {
  return (
    <div className="rounded-lg overflow-hidden">
      <div className="p-2">
        <div className="rounded-lg overflow-hidden">
          <EventImageSquare image={image} title={title} eventImages={eventImages} />
        </div>
      </div>
    </div>
  );
};
